import { Link, Outlet } from 'react-router'
import { AppUpdateProvider } from '@/features/app-update/AppUpdateProvider'
import { useSessionRefresh } from '@/features/auth/use-session-refresh'
import { useMessages } from '@/features/language/use-language'
import { IconButton } from '@/shared/ui/IconButton'
import { GearIcon } from '@/shared/ui/icons'

/**
 * 헤더가 갖는 것은 설정으로 들어가는 자리 하나다. 톱니 아이콘이고 라벨을 곁들이지 않는다.
 * 헤더에 서는 것이 제품 이름과 이 자리 둘뿐이라 글자가 둘이면 헤더가 낱말 두 개의 목록으로
 * 읽힌다. 낱말은 접근성 이름과 포인터가 머무를 때 뜨는 이름으로 준다.
 *
 * 헤더는 어느 화면에서나 늘 보이는 자리다. 나가는 문이나 꾸미는 자리를 상시로 걸어 두면 기록을
 * 읽는 내내 그것이 눈에 들어온다. 홈은 머무는 자리이지 지나가는 로비가 아니다. 분위기와
 * 로그아웃은 설정 안에 있다.
 */
export function AppLayout() {
  const m = useMessages()

  useSessionRefresh()

  return (
    <AppUpdateProvider>
      <div className="bg-canvas text-ink min-h-full">
        <header className="border-border/60 mx-auto flex max-w-2xl items-center justify-between gap-4 border-b px-5 py-3">
          <Link to="/" className="font-serif text-xl tracking-tight">
            mlog
          </Link>
          <IconButton label={m.app.layout.settings} to="/settings">
            <GearIcon />
          </IconButton>
        </header>
        <main className="mx-auto max-w-2xl px-5 pt-6 pb-24">
          <Outlet />
        </main>
      </div>
    </AppUpdateProvider>
  )
}
